import { ChakraProvider } from "@chakra-ui/react";
import { skyView, planetFitness, crunch } from "@radianse/themes";
import React, { useEffect, useState } from "react";
import useLocalStorage from "../hooks/useLocalStorage.js";

const themeMap = {
  skyview: skyView,
  planetfitness: planetFitness,
  crunch: crunch,
};

const ThemeContext = React.createContext(null);

export const useTheme = () => {
  return React.useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
  const [storedTheme, setStoredTheme] = useLocalStorage("theme");

  const switchTheme = (themeName) => {
    const selectedTheme = themeMap[themeName] ? themeName : "skyview";
    setTheme(selectedTheme);
  };

  const [theme, setTheme] = useState(
    themeMap[storedTheme] ? storedTheme : "skyview"
  );

  useEffect(() => {
    setStoredTheme(theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={[theme, switchTheme]}>
      <ChakraProvider theme={themeMap[theme]}>{children}</ChakraProvider>
    </ThemeContext.Provider>
  );
};
